import ProtectedRoute from '@Components/ProtectedRoute';
import { Outlet } from 'react-router-dom';

export default function TicketedEventsProtectedLayout() {
  return (
    <ProtectedRoute permissions={['EVENTS_READ']}>
      <Outlet />
    </ProtectedRoute>
  );
}
